import { render, staticRenderFns } from "./EfficiencyLomStatus.vue?vue&type=template&id=54fa79f2"
import script from "./EfficiencyLomStatus.vue?vue&type=script&lang=js"
export * from "./EfficiencyLomStatus.vue?vue&type=script&lang=js"
import style0 from "./EfficiencyLomStatus.vue?vue&type=style&index=0&id=54fa79f2&prod&lang=scss"
import style1 from "./EfficiencyLomStatus.vue?vue&type=style&index=1&id=54fa79f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports